import { useCallback } from 'react';
import { API } from '../../helpers';
import { unwrapCommercialV106 } from './shared';
import useKeyOptionsQueryV1110 from './useKeyOptionsQueryV1110';

export const keyOptionsConfigV1110 = (signal) => ({
  signal,
  timeout: 30000,
  keyOptionsV1110: true,
});

export default function useKeyCommercialOptionsV1110(
  targetUserId,
  enabled = true
) {
  const load = useCallback(
    async (signal) => {
      const response = await API.get('/api/user/commercial-options', {
        ...keyOptionsConfigV1110(signal),
        params: { user_id: targetUserId || undefined },
      });
      const data = unwrapCommercialV106(response);
      if (!data || !Array.isArray(data.sources))
        throw new Error('Invalid Key options');
      return data;
    },
    [targetUserId]
  );
  return useKeyOptionsQueryV1110(String(targetUserId || 'self'), enabled, load);
}
